import React from "react";
import { motion } from "framer-motion";
import { RegistrationInputButton } from "@/components/valuation/RegistrationInputButton";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

interface ContactHeaderProps {
  darkOverlayOpacity: number;
}

const ContactHeader = ({ darkOverlayOpacity }: ContactHeaderProps) => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const headerData = labels.menuPages?.sellCar?.contactSection?.header || {};

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      className="text-center mb-16"
    >
      <h2
        className={`text-4xl md:text-5xl font-bold mb-6 transition-colors duration-500 ${
          darkOverlayOpacity > 0.3 ? "text-white" : "text-gray-900"
        }`}
      >
        {headerData.title || "Redo att Sälja Din Bil?"}
      </h2>
      <p
        className={`text-xl max-w-3xl mx-auto leading-relaxed transition-colors duration-500 mb-8 ${
          darkOverlayOpacity > 0.3 ? "text-gray-300" : "text-gray-600"
        }`}
      >
        {headerData.description ||
          "Kontakta oss idag för en kostnadsfri värdering och kom igång med försäljningsprocessen idag."}
      </p>
    </motion.div>
  );
};

export default ContactHeader;
